//  Page Title: Setup 2FA Verification for WordPress Sites

import { MdFingerprint, MdLogin, MdOutlineShoppingCart, MdOutlineSms } from "react-icons/md";

// Main Video: https://youtu.be/mftn-shZx1U
export const mfaData = [
    {
        title: "Setup OTP Verification (WooCommerce Registration Form)",
        video: true,
        videoId: "2hu_QO6yLgA",
        videoType: "youtube",
        icon: <MdFingerprint className='text-white fs-5' />
    },
    {
        title: "Set order notification for WooCommerce",
        video: true,
        videoId: "EW4P00Z7TdA",
        videoType: "youtube",
        icon: <MdOutlineShoppingCart className='text-white fs-5' />
    },
    {
        title: "2FA for WordPress login",
        video: true,
        videoId: "mftn-shZx1U",
        videoType: "youtube",
        icon: <MdLogin className='text-white fs-5' />
    },
    {
        title: "Configure SMS gateways (Twilio) ",
        video: true,
        videoId: "25VUwIacvVk",
        videoType: "youtube",
        icon: <MdOutlineSms className='text-white fs-5' />
    },
]